'use strict'
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

class ButtonComponent extends Component {

    constructor(props) {
        super(props);
        this.generateButton = this.generateButton.bind(this);
        this.generateButtonDropdown = this.generateButtonDropdown.bind(this);
        this.buttonType = {
            "add": "addButton",
            "addSec":"addSecondaryButton",
            "edit": "editButton",
            "dropdown": "dropdownButton",
            "save": "saveButton",
            "cancel": "cancelButton",
            "file": "fileFormat",
            "import": "importCSV",
            "export": "exportCSV",
        }
    }

    generateButton(buttonConfig, modal_id = null) {
        let that = this;
        let button_element = (Object.values(buttonConfig)).map((innerData, i) => {
            let button_content = null;
            let button_position = null;
            let button_order = null;


            let data_toggle = innerData["modal_id"] && innerData["modal_id"] !== null ? "modal" : null;

            let showButton = innerData["display"] ? null : "hidden";

            if (innerData["position"] !== null && innerData["position"] !== undefined) {

                button_position = innerData["position"] == "right" ? "mg-l-auto" : "mg-l-5";
            }

            // if (innerData["order"] !== null && innerData["order"] !== undefined ){
            //     button_order = `order-${innerData["order"]}`;
            // }

            if (innerData["type"] == "normal") {

                let id = (that.buttonType[innerData['action']] !== null && that.buttonType[innerData['action']] !== undefined) ? that.buttonType[innerData['action']] : innerData['action'];

                button_content = (<a key={`${i}_${innerData['action']}`} id={id} className={`btn btn-sm btn-primary text-white  mg-r-10 text-truncate ${button_position} ${button_order}`} style={{height:"36px"}}type="button" data-bs-toggle={data_toggle} onClick={that.props.action} data-bs-target={innerData["modal_id"]} hidden={showButton} href={innerData.link ? innerData.link : null}>{innerData.label}</a>);
            }
            else if (innerData["type"] == "dropdown") {
                button_content = (
                    <div className="dropdown ">
                        <button key={`${i}_${innerData['action']}`} className="dropdown btn btn-sm btn-primary dropdown-toggle " type="button" id="moreDropdownButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" hidden={showButton} style={{height:"36px"}}>
                            {innerData.label}
                        </button>
                        <div className="dropdown-menu" aria-labelledby="moreDropdownButton">
                            {this.generateButtonDropdown(innerData["children"])}
                        </div>
                    </div>);
            }
            else if(innerData['type'] == "loading") {
                button_content = (<button key={`${i}_${innerData['id']}`} className={`btn btn-sm btn-primary text-white ${button_position} ${button_order}`} id={innerData['id']} type="button" hidden={showButton} disabled style={{height:"36px"}}>
                    <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span>
                    Please wait, Updating data...
                </button>);
            }
            return button_content;
        });
        return button_element;
    }


    generateButtonDropdown(dropdownConfig) {
        let that = this;
        let dropdown_elements = [];
        dropdown_elements = dropdownConfig.map((innerData, i) => {
            return (<a key={`${i}_${innerData['action']}`} id={that.buttonType[innerData['action']]} onClick={that.props.action} className="dropdown-item" style={{ "cursor": "pointer" }}>{innerData['label']}</a>);
        });
        return dropdown_elements;
    }

    render() {
        let buttonComponent = this.generateButton(this.props.buttonConfig, null);
        return (
            <>{buttonComponent}</>
        );
    }
}

export default ButtonComponent;